import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerifiedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"verified"}/>
}
